import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "topSort--sprite",
  "use": "topSort--sprite-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol viewBox=\"0 0 8 4\" xmlns=\"http://www.w3.org/2000/svg\" id=\"topSort--sprite\">\n  <path d=\"M3.64645 0.353553C3.84171 0.158291 4.15829 0.158291 4.35355 0.353553L7.14645 3.14645C7.46143 3.46143 7.23835 4 6.79289 4H1.20711C0.761654 4 0.538571 3.46143 0.853553 3.14645L3.64645 0.353553Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol